import { useState, useEffect } from 'react'
import { CONSTANTS } from '../utils/constants'

// Global state to keep all timers synchronized
let globalTimeLeft = CONSTANTS.COUNTDOWN_START_SECONDS
const listeners = new Set<React.Dispatch<React.SetStateAction<number>>>()

let intervalId: number | null = null

const startGlobalTimer = () => {
  if (!intervalId) {
    intervalId = window.setInterval(() => {
      globalTimeLeft = Math.max(0, globalTimeLeft - 1)
      listeners.forEach((listener) => listener(globalTimeLeft))
      if (globalTimeLeft === 0 && intervalId) {
        clearInterval(intervalId)
      }
    }, 1000)
  }
}

export const useCountdown = () => {
  const [timeLeft, setTimeLeft] = useState(globalTimeLeft)

  useEffect(() => {
    listeners.add(setTimeLeft)
    startGlobalTimer()

    return () => {
      listeners.delete(setTimeLeft)
    }
  }, [])

  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60

  return {
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
    isExpired: timeLeft === 0,
  }
}
